export default {
  store: {
    list: {
      title: '登録済み店舗',
       tableHeader: {
        index: "番号",
        storeName: "店舗名",
        receiptName: "レシート名",
        category: "カテゴリ",
        industryDetail: "業種詳細",
        address: "住所",
        status: "ステータス"
      },
      deleteConfirm: "店舗「{name}」を削除してもよろしいですか？",
      empty: "店舗情報がまだ登録されていません"
    },
      notice: {
        icon: "!",
        title: "店舗情報登録の注意事項",
        item1: "決済をご利用のすべて店舗情報をご記入ください。",
        item2: "「店舗名」は全角32文字以内、記号の使用は不可となります。ご了承ください。",
        
        item3: {
          title: "店舗情報のURLがない場合は下記を提出してください：",
          sub1: "店舗外観（店舗名が入っているもの）",
          sub2: "商品商材がわかるもの（陳列場所、メニュー表）"
        },
        item4: "上記が用意できない場合は「書類アップロード」のページにある詳細をご確認ください。",
        
      },

    banknotice: {
      title: '決済精算入金用銀行口座情報',
      tips: '入金口座情報変更をご希望の加盟店様は、申請中変更ができない場合があります。',
      noticeItems: [
        'ステータスが「申請成功」以外、またはエラーが発生した場合は、弊社にその旨ご連絡ください。',
        '入金口座情報変更の際は別途確認のご連絡が入る事がございます。',
        '口座情報を確認した上で、誤入力しないようにご注意ください',
        '30万円未満精算する場合、口座ごとに振込手数料220円（税込）を差し引かせて頂きます。'
      ],
    },

    
    login: {
      title: '店舗登録（＊必須項目）',
      label1: '店舗名',
      tip1: '例：環球支付',
      label2: '全角カタカナ',
      tip2: '例：カンキュウシフ',
      label3: '英文表記',
      tip3: '例：GLOBEPAY',
      label4: '業種（カテゴリ）',
      tip4: '選択',
      label5: '業種（詳細）',
      tip5: '選択',
      label6: '商材の詳細',
      tip6: '例：電気製品',
      label7: 'ホームページURL',
      tip7: '例：https://www.globepay.co.jp',
      label8: '店舗の外観内観の写真',
      tip8: 'ファイル形式：JPEG、PNG、JPG。ファイルサイズ制限：10MB内',
      label9: '取扱商品最小単価／円：',
      tip9: '0',
      label10: '取扱商品最大単価／円：',
      tip10: '0',
      label11: '店舗用口座',
      tip11: '例：1832',
      label12: '地図掲載希望可否',
      tip12: '',
      label13: '営業時間',
      tip13: '',
      label14: '定休日',
      tip14: '',
       label15: '店舗営業開始(予定)日',
      tip15: '',
    },
    home: {
      title: '店舗住所情報',
      label1: '郵便番号',
      tip1: '例：1030026',
      label2: '建物名及び部屋番号',
      tip2: '例：1-1008',
      label3: '電話番号',
      tip3: '例：03-6284-2302',
      label4: 'メールアドレス：',
      tip4: '例：xxx@gmail.com（※メールアドレスは重要です。 申請内容の連絡及び決済システムのID/PWのお知らせ。）',
      label5: '営業許可番号等',
      tip5: '例：T123456',
    },
    bank: {
      title: '入金用銀行口座情報',
      label1: '金融機関コード',
      tip1: '例：0001',
      label2: '金融機関名',
      tip2: '例：みずほ銀行',
      label3: '支店コード',
      tip3: '例：001',
      label4: '支店名',
      tip4: '例：法人営業部',
      label5: '口座番号',
      tip5: '例：1234567',
      label6: '口座種別',
      tip6: '例：普通',
      label7: '口座名義',
      tip7: '例：環球支付',
      label8: '半角ｶﾀｶﾅ',
      tip8: '例：ｶﾝｷｭｳｼﾌ',
    },
    copyaddressbtn:'本社住所から複製',
    deleteConfirm: '店舗の削除を確定',
    cancel: 'キャンセル',
    ok:'を選択して、',
    submit: '提出する',
    phone: '電話番号:'
  }
}
